import CreditCardType from 'credit-card-type';

const creditCardDetails = (cardNumber: string | number) => {
  const modifiedCardNumber = cardNumber?.toString()?.split(' ')?.join('');

  const last4 = modifiedCardNumber?.substring(modifiedCardNumber.length - 4);
  const first6 = modifiedCardNumber?.substring(0, 6);

  const cardDetails = CreditCardType(modifiedCardNumber)?.[0];
  return {
    type: cardDetails?.type,
    gaps: cardDetails?.gaps,
    niceType: cardDetails?.niceType,
    maxLength: cardDetails?.lengths ? Math.max(...cardDetails?.lengths) + cardDetails?.gaps.length : 16,
    code: cardDetails?.code,
    last4,
    first6,
    cvvLength: cardDetails?.code?.size || 4,
    cvvLabel: cardDetails?.code?.name || 'CVV',
    modifiedCardNumber,
  };
};

export { creditCardDetails };
